import { APP_V2_USER_EVENTS, logError, logEvent } from "@src/appV2/lib/analytics";

import { type OnboardingStage } from "./constants";

type OnboardingFunnelData = Partial<{
  email?: string;
  firstName?: string;
  lastName?: string;
  preferenceDistance?: number;
  dob?: string;
  phone?: string;
  workerId: string;
  hcpEventValue?: string;
  requirementId?: string;
  licenseType?: string;
  licenseExpiration?: string;
  licenseState?: string;
  licenseNumber?: string;
  didFeatureFlagGuessRegionCorrectly?: boolean;
}>;

export type OnboardingEventName = typeof APP_V2_USER_EVENTS.ENTERED_APP;

export function logOnboardingEvent(eventName: OnboardingEventName, data: OnboardingFunnelData) {
  try {
    const { workerId } = data;
    logEvent(eventName, {
      workerId,
      ...data,
    });
  } catch {
    logEvent(APP_V2_USER_EVENTS.ONBOARDING_ERROR, {
      message: "Unable to fire segment log",
      eventName,
      workerId: data.workerId,
    });
  }
}

export function logOnboardingError(
  stage: OnboardingStage,
  error: Error,
  metadata: {
    workerId?: string;
    eventMeta?: Record<string, string | undefined>;
  }
) {
  const { workerId, eventMeta } = metadata;
  logError(APP_V2_USER_EVENTS.ONBOARDING_ERROR, {
    error,
    metadata: {
      title: `Signup API failed to complete ${stage} stage`,
      logArea: "SERVER",
      logType: APP_V2_USER_EVENTS.ONBOARDING_ERROR,
      featureName: "SIGNUP",
      workerId,
      ...eventMeta,
    },
  });
}
